import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import "./Packages.css";
import PopupDialog from "../../components/common/PopupDialog";
import ContactForm from "../../components/contactForm/ContactForm";
import buildingSketch from "../../assets/images/DesignDiagram.jpg";
import {
  packageColumns as columns,
  packageSections as sections,
} from "../../data/PackagesData";

export default function Packages() {
  const [openQuote, setOpenQuote] = useState(false);

  return (
    <Box className="packages-page">
      {/* Header Section */}
      <Box
        className="header-section"
        sx={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.95), rgba(255,255,255,0.95)), url(${buildingSketch})`,
        }}
      >
        <Container>
          <Typography variant="h3" component="h1" className="header-title">
            Packages & Specifications
          </Typography>
        </Container>
      </Box>

      <Container className="content-container">
        {/* Intro Section */}
        <Box className="intro-section">
          <Typography variant="h4" gutterBottom className="intro-title">
            Choose Your Ideal Construction Package
          </Typography>
          <Box
            sx={{
              width: "60px",
              height: "4px",
              backgroundColor: "#4285f4",
              margin: "0 auto 24px auto",
            }}
          />
          <Typography
            variant="body1"
            className="intro-text"
            sx={{ maxWidth: "800px", mx: "auto" }}
          >
            Transparent, quality-driven construction packages designed for trust
            and long-term durability. Compare specifications across packages to
            choose what best fits your needs.
          </Typography>
        </Box>

        {/* Mobile View (Cards) */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          {/* Mobile Pricing Summary Section */}
          <Box className="mobile-pricing-summary">
            <Typography variant="h6" className="mobile-section-title">
              Pricing Overview
            </Typography>
            <Box className="mobile-pricing-grid">
              {columns.map((col) => (
                <Box key={col.key} className={`mobile-pricing-card ${col.key}`}>
                  <Typography className="pricing-title">{col.title}</Typography>
                  <Typography className="pricing-cost">
                    ₹{col.price} <span className="unit">/sq.ft</span>
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Feature Sections */}
          {sections.map((section) => (
            <Box key={section.number} className="mobile-section-block">
              <Typography variant="h6" className="mobile-section-title">
                {section.number}. {section.title}
              </Typography>
              {section.rows.map((row, idx) => (
                <Box
                  key={`${section.number}-${idx}`}
                  className="mobile-package-card"
                >
                  <Typography className="mobile-feature-name">
                    {row.label}
                  </Typography>
                  <Box className="mobile-package-grid">
                    {columns.map((col) => (
                      <Box
                        key={col.key}
                        className={`mobile-package-item ${col.key}`}
                      >
                        <Typography className="pkg-name">
                          {col.title}
                        </Typography>
                        <Typography className="pkg-value">
                          {row[col.key]}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              ))}
            </Box>
          ))}
        </Box>

        {/* Desktop View (Table) */}
        <TableContainer
          component={Paper}
          className="packages-table-container"
          elevation={0}
          sx={{ display: { xs: "none", md: "block" } }}
        >
          <Table className="packages-table">
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ width: 80 }}>
                  SL.NO
                </TableCell>
                <TableCell>Description</TableCell>
                {columns.map((col) => (
                  <TableCell key={col.key} align="center">
                    <Box className="header-cell-content">
                      <span className="header-pkg-title">{col.title}</span>
                      <span className="header-pkg-price">
                        <span className="currency-symbol">₹</span>
                        {col.price} <span className="per-sqft">/ sq.ft</span>
                      </span>
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sections.map((section) => (
                <React.Fragment key={section.number}>
                  <TableRow className="section-row">
                    <TableCell align="center" className="section-number">
                      {section.number}
                    </TableCell>
                    <TableCell
                      className="section-title"
                      colSpan={columns.length + 1}
                    >
                      {section.title}
                    </TableCell>
                  </TableRow>
                  {section.rows.map((row, idx) => (
                    <TableRow
                      key={`${section.number}-${idx}`}
                      hover
                      className="package-data-row"
                    >
                      <TableCell />
                      <TableCell className="desc-cell">{row.label}</TableCell>
                      <TableCell className="value-cell" align="center">
                        {row.luxury}
                      </TableCell>
                      <TableCell className="value-cell" align="center">
                        {row.standard}
                      </TableCell>
                      <TableCell className="value-cell" align="center">
                        {row.basic}
                      </TableCell>
                    </TableRow>
                  ))}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <PopupDialog
        open={openQuote}
        title="Request a Quote"
        onClose={() => setOpenQuote(false)}
        maxWidth="md"
      >
        <ContactForm
          title="Start Your Dream Project"
          subtitle="Contact us for more details"
          buttonText="Request Consultation"
          onSubmit={() => setOpenQuote(false)}
        />
      </PopupDialog>
    </Box>
  );
}
